import { Link, Redirect, useRouter } from 'expo-router'
import { useIntl } from 'react-intl'
import { Platform, ScrollView, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { DonationButton } from '@/src/elements/button/donation/DonationButton'
import { Header } from '@/src/elements/header'
import { Image } from '@/src/elements/image'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { DONATION_SOURCE } from '@/src/features/donation/api/types/donation'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useDimensions } from '@/src/general/hooks/useDimensions'
import { getDeviceInfos } from '@/src/general/utils/getDeviceInfos'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

const app_hozana_picture = {
  fr: require('@/assets/img/app/app_hozana_fr.png'),
  en: require('@/assets/img/app/app_hozana_en.png'),
  es: require('@/assets/img/app/app_hozana_es.png'),
  pt: require('@/assets/img/app/app_hozana_pt.png'),
  it: require('@/assets/img/app/app_hozana_en.png'),
  pl: require('@/assets/img/app/app_hozana_en.png'),
}

const android_play_store = {
  fr: require('@/assets/img/app/google_play_fr.png'),
  en: require('@/assets/img/app/google_play_en.png'),
  es: require('@/assets/img/app/google_play_es.png'),
  pt: require('@/assets/img/app/google_play_pt.png'),
  it: require('@/assets/img/app/google_play_en.png'),
  pl: require('@/assets/img/app/google_play_en.png'),
}

const ios_app_store = {
  fr: require('@/assets/img/app/apple_store_fr.png'),
  en: require('@/assets/img/app/apple_store_en.png'),
  es: require('@/assets/img/app/apple_store_es.png'),
  pt: require('@/assets/img/app/apple_store_pt.png'),
  it: require('@/assets/img/app/apple_store_en.png'),
  pl: require('@/assets/img/app/apple_store_en.png'),
}
export const appStoreLink =
  'https://apps.apple.com/app/hozana/id1477461388?utm_campaign=app_store_Hozana&utm_source=site_Hozana'

export const playStoreLink =
  'https://play.google.com/store/apps/details?id=org.hozana.app&utm_campaign=play_store_Hozana&utm_source=site_Hozana'

export const AppScreen = () => {
  const { routes } = useRoutes()
  const { navigate } = useRouter()
  const { handleBackPress } = useBackHandlePress(routes.home())
  const { locale } = useIntl()
  const { t } = useTranslate()
  const { lessThan } = useDimensions()
  const { device } = getDeviceInfos()

  if (Platform.OS === 'ios') {
    return <Redirect href={appStoreLink} />
  } else if (Platform.OS === 'android') {
    return <Redirect href={playStoreLink} />
  }

  return (
    <>
      <ScrollView showsVerticalScrollIndicator={!lessThan.md}>
        <Header
          leftButtons={[{ startIcon: ICON.ARROW_LEFT, onPress: handleBackPress, type: 'icon' }]}
          rightButtons={[
            {
              type: 'button',
              component: () => <DonationButton donationSource={DONATION_SOURCE.HEADER} />,
            },
          ]}
        />
        <View className="mx-auto flex max-w-[500px] items-center justify-center gap-9 px-5 pb-24 pt-5 xm:px-4 xm:pt-0">
          <Icon testID={TEST_ID.APP.LOGO} name={ICON.HOZANA} className="h-auto w-[200px] xm:w-[300px]" />
          <View className="mx-auto h-60 w-48 xm:h-80 xm:w-64">
            <Image testID={TEST_ID.APP.IMAGE} source={app_hozana_picture[locale]} />
          </View>
          <Typography colors="primary" contrast="default" className="text-center">
            {t('app.description')}
          </Typography>
          {lessThan.xm ? (
            <Button
              testID={TEST_ID.APP.DOWNLOAD_BUTTON}
              onPress={() => navigate('vendor' in device && device.vendor === 'Apple' ? appStoreLink : playStoreLink)}
              colors="primary"
              variant="solid"
              className="w-full"
            >
              {t('app.download')}
            </Button>
          ) : (
            <View className="flex flex-row flex-wrap items-center justify-center gap-6 pb-1">
              <View className="h-14 w-48">
                <Link href={playStoreLink} className="h-full w-full">
                  <Image
                    testID={TEST_ID.APP.ANDROID_PLAY_STORE}
                    source={android_play_store[locale]}
                    className="rounded-none"
                  />
                </Link>
              </View>
              <View className="h-14 w-48">
                <Link href={appStoreLink} className="h-full w-full">
                  <Image testID={TEST_ID.APP.IOS_APP_STORE} source={ios_app_store[locale]} className="rounded-none" />
                </Link>
              </View>
            </View>
          )}
        </View>
      </ScrollView>
    </>
  )
}
